module.exports = __webpack_public_path__ + "img/Like.5a1377bf.png";